// ModelViewer.jsx
import React, { useEffect, useState } from "react";

const ModelViewer = ({ modelUrl, patient, onBack }) => {
  const [loading, setLoading] = useState(true);
  const [viewerUrl, setViewerUrl] = useState(null);
  const [modelJson, setModelJson] = useState(null); // ✅ keep model JSON in state
  const UNITY_WEBGL_URL = window.UNITY_WEBGL_URL;


//  useEffect(() => {
//    console.log("modelUrl: " + modelUrl);
//    fetch(modelUrl)
//      .then((res) => res.json())
//      .then((data) => {
//        if (data.success) {
//          setViewerUrl(`${UNITY_WEBGL_URL}`);
//        }
//      })
//      .finally(() => setLoading(false));
//  }, [modelUrl, patient]);
  
  useEffect(() => {
    //console.log("modelUrl: " + modelUrl);
    //console.log("patient: " + JSON.stringify(patient));
    //console.log("patient.patientName: " + patient.patientName);
    //console.log("patient.studyDate: " + patient.studyDate);

    fetch(modelUrl)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          // Step 1: set iframe URL
          setViewerUrl(`${UNITY_WEBGL_URL}`);
          setModelJson(data.data);      // ✅ store JSON safely

//          // Step 2: Wait a little for iframe to load, then send JSON
//          setTimeout(() => {
//            const iframe = document.querySelector(
//              "iframe[title='3D Model Viewer']"
//            );
//            if (iframe) {
//              iframe.contentWindow.postMessage(
//                { type: "LOAD_MODEL", payload: data.data }, // <-- your model JSON
//                "*"
//              );
//              console.log("📤 Sent model JSON to Unity iframe");
//            }
//          }, 2000); // 2s delay to ensure Unity loads
        }
      })
      .finally(() => setLoading(false));
  }, [modelUrl, patient]);  
  
  

  return (
    
      <div className="min-h-screen bg-gray-100 max-w-6xl mx-auto shadow rounded-lg overflow-hidden">
        {/* Title bar */}
        <div className="flex justify-between items-center bg-gray-300 px-4 py-2 border-b">
          <h3 className="text-lg font-semibold text-gray-700">3D Model Viewer</h3>
          {(patient && patient.patientName) && (
            <span className="ml-4 text-sm font-medium text-gray-600">
              {patient.studyDate != "-"
                ? `(Name: ${patient.patientName} | Study Date: ${patient.studyDate})`
                : `Name: ${patient.patientName}`
              }
            </span>
          )}
          <button
            onClick={onBack}
            className="px-3 py-1 bg-gray-600 text-white rounded hover:bg-gray-700"
          >
            ← Back
          </button>
        </div>

        {/* Viewer area */}
        <div
          className="
            relative w-full 
            h-[650px]   /* desktop default */
            bg-black
            md:h-[650px]   /* medium+ screens fixed height */
            sm:h-[calc(100vh-100px)]  /* small screens: expand to full height minus header */
          "
        >
          {loading && (
            <div className="absolute inset-0 flex items-center justify-center text-white">
              Loading Model...
            </div>
          )}
          {viewerUrl && (
            <iframe
              src={viewerUrl}
              className="w-full h-full border-none"
              title="3D Model Viewer"
              allowFullScreen
              onLoad={(e) => {
                //console.log("✅ Unity iframe loaded, sending JSON");
                if (modelJson) {
                  e.target.contentWindow.postMessage(
                    { type: "LOAD_MODEL", payload: modelJson },
                    "*"
                  );
                  //console.log("📤 Sent model JSON:", modelJson);
                }
              }}            
            />
          )}
        </div>
      </div>

  );
};

export default ModelViewer;
